<template>
  <organism-global-setting></organism-global-setting>
</template>

<script>
import OrganismGlobalSetting from "@/components/organisms/globalSetting/OrganismGlobalSetting.vue"
import VueScreenSize from "vue-screen-size"
import store from "@/store/index"

export default {
  name: "GlobalSetting",
  components: { OrganismGlobalSetting },
  mixins: [VueScreenSize.VueScreenSizeMixin],
  computed: {
    screenWidth() {
      return this.$vssWidth
    },
  },
  watch: {
    screenWidth: {
      deep: true,
      immediate: true,
      handler() {
        if (this.screenWidth < 1200) {
          store.dispatch("appConfig/setLayoutSidebar", true)
        } else {
          store.dispatch("appConfig/setLayoutSidebar", false)
        }
      },
    },
  },
}
</script>

<style></style>
